import { connect } from 'react-redux';
import { FileUploader } from '../../components';
import { getFileUploadMaxSizeState } from '../../selectors';
const mapStateToProps = (state, ownProps) => {
    var _a;
    const maxVideoFileSize = (_a = getFileUploadMaxSizeState(state)) === null || _a === void 0 ? void 0 : _a.maxVideoFileSize;
    return Object.assign(Object.assign({}, ownProps), { maxVideoFileSize });
};
export const ConnectedFileUploader = connect(mapStateToProps)(FileUploader);
//# sourceMappingURL=ConnectedFileUploader.js.map